import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { Button } from './Button';
export function FinalCTA() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const handlePurchase = () => {
    window.location.href = 'https://www.consejossimples.com/cart/53390925005133:1';
  };
  return <section ref={ref} className="w-full bg-terracotta text-cream px-4 py-16 md:py-24" data-id="element-17">
      <div className="max-w-4xl mx-auto text-center" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8
      }} data-id="element-19">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold mb-8" data-id="element-20">
            Si hoy sentís que el pan es "tentación + culpa", te entiendo.
          </h2>

          <p className="font-body text-xl md:text-2xl mb-12 leading-relaxed" data-id="element-21">
            Pero te prometo algo:{' '}
            <span className="font-bold" data-id="element-22">se puede volver a disfrutar</span>.
          </p>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={isInView ? {
          opacity: 1,
          scale: 1
        } : {
          opacity: 0,
          scale: 0.95
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} data-id="element-23">
            <Button variant="secondary" size="lg" onClick={handlePurchase} className="mb-8 text-xl" data-id="element-24">
              Hacé Click y Llevate "Panadería sin Culpa" Ahora
            </Button>
          </motion.div>

          <motion.p initial={{
          opacity: 0
        }} animate={isInView ? {
          opacity: 1
        } : {
          opacity: 0
        }} transition={{
          duration: 0.8,
          delay: 0.5
        }} className="font-body text-lg mb-4" data-id="element-25">
            Te espero adentro, en mi cocina.
          </motion.p>

          <motion.p initial={{
          opacity: 0
        }} animate={isInView ? {
          opacity: 1
        } : {
          opacity: 0
        }} transition={{
          duration: 0.8,
          delay: 0.7
        }} className="font-heading text-2xl md:text-3xl font-bold" data-id="element-26">
            — Chef Martina Guez
          </motion.p>
        </motion.div>
      </div>
    </section>;
}